import React from "react";
import { Link } from "react-router-dom";
import Header from "@/components/landing/Header";
import PageFooter from "@/components/landing/PageFooter";

export default function ExperienceThankYou() {
  return (
    <main
      data-testid="experience-thankyou-page"
      className="bg-warm text-graphite min-h-screen flex flex-col"
    >
      <Header />
      <div className="pt-24 md:pt-28" />

      <section
        data-testid="thankyou-hero"
        className="flex-1 px-6 md:px-10 py-14 md:py-20"
      >
        <div className="max-w-2xl mx-auto text-center">
          {/* Small ornamental mark */}
          <div
            aria-hidden="true"
            className="font-serif-display italic text-gold text-[60px] md:text-[80px] leading-none mb-6 select-none"
            style={{ opacity: 0.8 }}
          >
            —
          </div>

          <h1
            data-testid="thankyou-title"
            className="font-serif-display text-[36px] sm:text-[44px] md:text-[52px] leading-[1.15] text-graphite tracking-tight mb-10"
          >
            Megérkezett a{" "}
            <em className="text-gold" style={{ fontStyle: "italic" }}>
              jelentkezésed
            </em>
            .
          </h1>

          <div className="reading-prose text-[16px] md:text-[17px] leading-[1.9] text-graphite font-body font-light space-y-5 text-left md:text-center">
            <p className="font-serif-display italic text-graphite text-[19px] md:text-[22px] leading-[1.6]">
              Köszönöm, hogy bizalmat adtál ennek a négy napnak.
            </p>
            <p>
              A következő lépésekkel, a díjbekérővel és a programhoz kapcsolódó részletekkel
              személyesen is jelentkezem. Addig is őrizd meg azt az első gondolatot vagy érzést,
              amely miatt most igent mondtál erre a lehetőségre. Lehet, hogy már ez is egy új irány
              kezdete.
            </p>
          </div>

          <div className="mt-14 md:mt-16 flex items-center gap-5 justify-center">
            <span className="h-px w-16 bg-gold" aria-hidden="true" />
            <p className="font-serif-display italic text-gold text-[20px] md:text-[24px]">
              Szász-Tóth Enikő
            </p>
            <span className="h-px w-16 bg-gold" aria-hidden="true" />
          </div>

          <div className="mt-14 md:mt-16">
            <Link
              to="/"
              data-testid="thankyou-back-link"
              className="inline-flex items-center gap-3 text-[12px] tracking-[0.3em] uppercase text-graphite hover:text-gold transition-colors duration-300 font-body pb-1 border-b border-gold"
            >
              Visszatérek a weboldalra
              <span aria-hidden="true">→</span>
            </Link>
          </div>
        </div>
      </section>

      <PageFooter />
    </main>
  );
}
